import { warehouseI, warehouseListI } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { warehousePaths } from "services/services.paths";

export const getWarehouse = async () => {
  const response = await get<warehouseListI[]>(warehousePaths.get);

  return response.data;
};

export const getWarehouseByBranch = async (branchId: string) => {
  const response = await get<warehouseListI[]>(
    warehousePaths.getByBranch + `${branchId}`
  );

  return response.data;
};


export const getWarehouseGet = async () => {
  const response = await get<warehouseListI[]>(warehousePaths.get);

  return response;
};

export const removeWarehouse = async (id: number) => {
  const response = await remove<any>(warehousePaths.delete + `/${id}`);

  return response;
};

export const createWarehouse = async (warehouse: warehouseI) => {
  const response = await post<any>(warehousePaths.post, warehouse);

  return response;
};

export const updateWarehouse = async (warehouseId: number, warehouse: warehouseI) => {
  const response = await patch<any>(
    warehousePaths.put + `/${warehouseId}`,
    warehouse
  );

  return response;
};
